module.exports = __webpack_public_path__ + "app/images/ozghub/favicon.ozghub.png";